import { render, staticRenderFns } from "./select-package-list.vue?vue&type=template&id=575c9e7a&scoped=true&"
import script from "./select-package-list.vue?vue&type=script&lang=js&"
export * from "./select-package-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c9e7a",
  null
  
)

export default component.exports